import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {NewsSectionLayout} from '@lib-modules/section/components/news-section/news-section.component';
import {Event} from '@api/models/event/event';
import {INewsPost} from '@api/models/news/news';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';
import {LeagueService} from '@core/services/league.service';
import {TeamService} from '@core/services/team.service';
import {PickerItem, PickerItemType} from '@lib-modules/picker/components/picker-item/picker-item.component';
import {ContentCardLayout} from '@lib-modules/cards/components/content-card/content-card.component';
import {AdCampaignPlacement} from '@api/models/ad-campaign/ad-campaign-placement';
import {AdCampaignService} from '@components/ad-campaign/services/ad-campaign.service';
import {AboBannerType} from '@lib-modules/banners/components/abo-banner/abo-banner.component';
import {NewsCardService, NewsContentType} from '@lib-modules/cards/services/news-card/news-card.service';
import {VideoCardService, VideoContentType} from '@lib-modules/cards/services/video-card/video-card.service';
import { IUser } from '@api/models/user/user';
import {EntityType} from '@lib/models/entity/entity-type';

@Component({
  selector: 'lib-entity-videos-section',
  templateUrl: './entity-videos-section.component.html',
  styleUrls: ['./entity-videos-section.component.scss']
})
export class EntityVideosSectionComponent implements OnInit {

  protected readonly AboBannerType = AboBannerType;
  @ViewChild('subSection') subSection: ElementRef<HTMLDivElement>;
  @Input() type: EntityType;
  @Input() colorScheme = ColorScheme.Dark;
  @Input() public pageSize = 16;
  @Input() public user: IUser;

  public entityId: string;
  public newsMixedLayout = NewsSectionLayout.Mixed;
  public newsRowLayout = NewsSectionLayout.Row;
  public livestreams: Event[] = [];
  public replays: Event[] = [];
  public showVideoContent = true;
  public editorialNews: INewsPost[] = [];
  public videoNews: INewsPost[] = [];
  public topTeams: PickerItem[];
  public selectedItem: PickerItem;
  public isLoading = false;
  public layout = ContentCardLayout.Stacked;
  public videoNewsType = NewsContentType.VideoNews;

  constructor(public leagueService: LeagueService,
              public teamService: TeamService,
              public adCampaignService: AdCampaignService,
              private videoCardService: VideoCardService,
              private newsCardService: NewsCardService, ) {
  }

  async ngOnInit() {
    this.adCampaignService.setPlacement(AdCampaignPlacement.Videos);
    switch (this.type) {
      case EntityType.Team:
        this.entityId = this.teamService.getCurrentTeamId();
        const teamItem = {
          objectId: this.teamService.getCurrentTeamId(),
          name: this.teamService.getCurrentTeam().name,
          readableId: this.teamService.getCurrentTeam().readable_id,
          type: PickerItemType.Team
        }
        await this.onItemSelect(teamItem);
        break
      case EntityType.League:
        this.setTopTeamsForLeague();
        break;
    }
  }

  private setTopTeamsForLeague() {
    if (this.topTeams) {
      return;
    }
    this.entityId = this.leagueService.getCurrentLeagueId();
    this.topTeams = this.leagueService.getCurrentTopTeamsAsPickerItems();
  }

  public async onItemSelect(selectedItem: PickerItem) {
    this.isLoading = true;
    this.selectedItem = selectedItem;
    this.showVideoContent = await this.videoCardService.showVideoContent(selectedItem);
    if (!this.showVideoContent) {
      this.isLoading = false
      return;
    }

    await this.loadVideoContent(selectedItem);
    this.isLoading = false
  }

  private async loadVideoContent(item: PickerItem) {
    this.livestreams = await this.videoCardService.fetchData(VideoContentType.ActiveStreams, item);
    this.replays = await this.videoCardService.fetchData(VideoContentType.Replay, item);
    this.editorialNews = await this.newsCardService.fetchData(NewsContentType.VideoNews, item, 0, 16, { editorial: true });
    this.videoNews = await this.newsCardService.fetchData(NewsContentType.VideoNews, item, 4, 8)
  }

  public get bannerName(): string {
    switch (this.type) {
      case EntityType.League:
        return this.leagueService.currentLeague.name
      case EntityType.Team:
        return this.selectedItem.name;
    }
  }
}
